import React from "react";
import { FileText, Download } from "lucide-react";
import { Reveal, ExternalLinkIcon, SectionLabel } from "./primitives";
import { documents } from "../data/content";
import { track } from "../lib/analytics";

const ext = { target: "_blank", rel: "noopener noreferrer" };

export const DocumentsLibrary = () => (
  <section
    id="documents"
    aria-labelledby="documents-heading"
    className="border-t border-brand-border bg-white py-16 lg:py-24"
  >
    <div className="mx-auto max-w-content px-4 lg:px-8">
      <Reveal className="max-w-2xl">
        <SectionLabel>Document library</SectionLabel>
        <h2
          id="documents-heading"
          className="mt-3 font-heading text-3xl font-bold tracking-tight text-brand-navy lg:text-4xl"
        >
          Important documents and information
        </h2>
        <p className="mt-3 text-lg leading-relaxed text-brand-body">
          The protocol conditions and guidance below apply to Freeman Jones proposals. Each
          document opens as a PDF in a new tab.
        </p>
      </Reveal>

      <ul className="mt-10 grid gap-4 md:grid-cols-2">
        {documents.map((doc, i) => (
          <Reveal
            as="li"
            key={doc.title}
            delay={(i % 2) * 0.08}
            className="group flex flex-col rounded-2xl border border-brand-border bg-brand-bg p-6 transition-transform duration-300 hover:-translate-y-1"
          >
            <div className="flex items-start gap-4">
              <span className="grid h-12 w-12 flex-shrink-0 place-items-center rounded-xl bg-brand-teal/10 text-brand-teal">
                <FileText className="h-6 w-6" aria-hidden="true" />
              </span>
              <div>
                <h3 className="font-heading text-lg font-bold leading-snug text-brand-navy">
                  {doc.title}
                </h3>
                <span className="mt-1 inline-block rounded-md bg-white px-2 py-0.5 text-xs font-semibold uppercase tracking-wide text-brand-teal">
                  {doc.fileType}
                </span>
              </div>
            </div>
            <p className="mt-4 flex-1 text-base leading-relaxed text-brand-body">
              {doc.description}
            </p>
            <a
              {...ext}
              href={doc.url}
              onClick={() => track("regulatory_document_clicked", { label: doc.fileType })}
              className="mt-5 inline-flex min-h-[48px] w-fit items-center justify-center gap-2 rounded-full border border-brand-navy px-5 text-center font-semibold text-brand-navy transition-colors hover:bg-brand-navy hover:text-white"
              data-testid={`document-${i}`}
              aria-label={`Open ${doc.title} (PDF) — opens in a new tab`}
            >
              <Download className="h-4 w-4" aria-hidden="true" /> Open document
              <ExternalLinkIcon />
            </a>
          </Reveal>
        ))}
      </ul>
    </div>
  </section>
);
